<template>
  <div class="peoplechoice">
    <Header :title="$t('m.Address')"></Header>
    <!-- <div class="serch bgc3">
      <span class="serchbox">
          <Icon type="ios-search"></Icon>
          <input @input='search' class="searchinput" placeholder="请输入姓名查询" type="text"
                  v-model="searchcontent">
      </span>
    </div>-->
    <!-- <div class="searchList">
       <Input search  placeholder="Enter something..." style="width: 300px" />
    </div>-->
    <Search />
    <List
      :letter="letter"
      :departmentInfo="departmentInfo"
      :subDepartments="subDepartments"
      :userList="userList"
      :isAll="isAll"
      :subDepartmentWithUsers="subDepartmentWithUsers"
      :userDirectList="userDirectList"
    />
    <Alphabet @change="handleLetterChange" :userList="userList" />

    <div @click="sure" class="bottom bgc">{{$t('m.OKBtn')}}</div>

    <!-- 弹框  开始 -->
    <div class="pop" v-if="popshow">
      <div class="templatepop">
        <div @click="closeallpop" class="popclosex">
          <Icon type="ios-close"></Icon>
        </div>
        <div style="height:1rem;text-align:center">
          <img :src="usermessage.image" alt style="height:1rem;width:1rem;border-radius:50%" />
        </div>
        <div class="contentitem">
          <span class="leftspan">{{$t('m.NameColon')}}</span>
          {{usermessage.name}}
        </div>
        <div class="contentitem">
          <span class="leftspan">{{$t('m.UnitColon')}}</span>
          {{usermessage.department}}
        </div>
        <div class="contentitem">
          <span class="leftspan">{{$t('m.MobileColon')}}</span>
          {{usermessage.mobile}}
        </div>
        <div class="contentitem">
          <span class="leftspan">{{$t('m.EMailColon')}}</span>
          {{usermessage.email}}
        </div>
        <div class="contentitem">
          <!-- <span class="leftspan">地址：</span> -->
        </div>
      </div>
    </div>
    <!-- 弹框  结束 -->
  </div>
</template>
<script>
import Header from "../header/header";
import Search from "./userlist/Search";
import List from "./userlist/list";
import Alphabet from "./userlist/Alphabet";
import {
  getFirstDepartment,
  getSecondDepartment,
  getUserByDepartmentId,
  getUserByDepartmentId1
} from "../../assets/js/url";

export default {
  name: "peoplechoice",
  data() {
    return {
      social: [],
      array: [],
      data: Object,
      myset: [],
      searchcontent: "",
      meetinguuid: "",
      usermessage: Object,
      popshow: false,
      departmentData: {},
      letter: "",
      departmentInfo: "",
      //二级部门列表
      subDepartments: [],
      //二级人员列表
      userList: {},
      //判断是一个部门是否取全选
      isAll: false,
      //
      subDepartmentWithUsers: [],
      userDirectList: {}
    };
  },
  components: {
    Header,
    List,
    Alphabet,
    Search
  },
  activated() {
    this.social = [];
    // this.getDepartment();
    this.getCheckinList();
    let storage = window.localStorage;
    this.departmentInfo = JSON.parse(storage.listInfo);
    // this.checkAll = this.$route.query.checkAll
    //加载 该部门下的部门列表以及总人数
    //this.getListInfo();
    this.isAll = this.$route.query.isAll;
    this.subDepartmentWithUsers = this.$route.query.subDepartmentWithUsers;
    this.userDirectList = this.$route.query.userDirectList;
  },
  methods: {
    handleLetterChange(letter) {
      this.letter = letter;
    },
    //获得该部门下的总列表部门和总人数
    getListInfo() {
      this.$http
        .post(getUserByDepartmentId1, {
          useruuid: window.sessionStorage.getItem("UUID"),
          departmentId: this.departmentInfo.id
        })
        .then(res => {
          if (res.data.status == 2000) {
            //获取到二级部门 需要传递到组件中
            this.subDepartments = res.data.data.subDepartmentWithUsers;
            this.userList = res.data.data.userDirectList;
          } else {
            this.$toast(this.$t('m.GetFail'));
          }
        });
    },
    getDepartment() {
      this.$http
        .post(getFirstDepartment, {
          useruuid: window.sessionStorage.getItem("UUID")
        })
        .then(res => {
          if (res.data.status === 2000) {
            let firstDepartmentData = res.data.data;
            for (let i = 0; i < firstDepartmentData.length; i++) {
              this.$http
                .post(getSecondDepartment, {
                  firstDepartmentId: firstDepartmentData[i].id,
                  useruuid: window.sessionStorage.getItem("UUID")
                })
                .then(res => {
                  if (res.data.status === 2000) {
                    let data = res.data.data;
                    this.departmentData[data[i].id] = data[i].name;
                  }
                });
            }
          }
        });
    },
    search() {
      if (this.searchcontent) {
        $(".title").css("display", "none");
        $(".contentitem").css("display", "none");
        $(
          ".contentitem:contains(" + this.searchcontent.toLowerCase() + ")"
        ).css("display", "block");
      } else {
        $(".title").css("display", "block");
        $(".contentitem").css("display", "block");
      }
    },
    tothis(item) {
      const top = $('[index="' + item + '"]').offset().top;
      $(window).scrollTop(top - $(window).height() * 0.2);
    },
    getusermessage(item) {
      this.usermessage = item;
      this.popshow = true;
    },
    closeallpop() {
      this.popshow = false;
    },
    getCheckinList() {
      this.$loadingshow();
      this.array = [];
      this.$http
        .post(getUserByDepartmentId, {
          useruuid: window.sessionStorage.getItem("UUID"),
          departmentId: ""
        })
        .then(
          res => {
            this.$loadingclose();
            if (res.data.status == 2000) {
              const data = res.data.data;
              const mymap = new Map();
              const hasname = [];
              // var haspingying=[]
              const hasdepartment = [];
              const set = data.map(function(item, index) {
                if ("name" in item && "useruuid" in item) {
                  mymap.set(item.useruuid, item.name);
                }
                if ("name" in item) {
                  hasname.push(item.name);
                }
                if ("department" in item) {
                  hasdepartment.push(item.departmentName);
                }
                if ("name" in item && "departmentName" in item) {
                  item.key = item.departmentName;
                  return item.departmentName;
                }
                // if("firstpinyin" in item ){
                //     haspingying.push(item.firstpinyin)
                // }
                // if ("name" in item && "firstpinyin" in item) {
                //   if (/^[0-9]*$/.test(item.name)) {
                //     item.key = "#";
                //     return "#";
                //   } else {
                //     item.key = item.firstpinyin.toUpperCase();
                //     return item.firstpinyin.toUpperCase();
                //   }
                // }
              });
              this.data = mymap;
              const myset = new Set(set);
              const key = Array.from(myset).sort();
              this.myset = key;
              this.array = [];
              for (let i = 0; i < key.length; i++) {
                this.array.push({
                  key: key[i],
                  array: data
                    .filter(function(item, index) {
                      return item.key == key[i];
                    })
                    .sort()
                });
              }
            } else {
              this.$toast(this.$t('m.AddressGetFail'));
            }
          },
          err => {
            this.$toast(this.$t('m.NetworkException'));
            this.$loadingclose();
          }
        );
    },
    sure() {
      this.$router.go(-1);
    }
  },
  watch: {},
  computed: {
    choice() {
      return " ";
    }
  }
};
</script>
<style scoped>
.peoplechoice {
  width: 100%;
}

.serch {
  height: 0.52rem;
  line-height: 0.52rem;
  padding: 0 0.15rem;
  font-size: 0.08rem;
  width: 100%;
  position: fixed;
  top: 0.44rem;
  left: 0;
  background-color: #fff;
  z-index: 100;
}

.choice {
  padding: 0.15rem 0.45rem 0.05rem 0.15rem;
  line-height: 0.3rem;
  padding-top: 0.5rem;
}

.serchbox {
  width: 2.2rem;
  height: 0.28rem;
  line-height: 0.32rem;
  display: inline-block;
  margin-top: 0.1rem;
  border-radius: 5px;
  border: 1px solid #ddd;
  /* float: left; */
  margin-right: 0.1rem;
  box-sizing: border-box;
  padding: 0 0.1rem;
}

.searchinput {
  width: 1.2rem;
  height: 0.32rem;
  border: none;
  background-color: transparent;
  outline: none;
  line-height: 0.32rem;
}

i {
  font-size: 0.2rem;
}

.title {
  padding: 0 0.15rem;
  height: 0.28rem;
  background-color: #f8f8f8;
  line-height: 0.28rem;
  font-size: 0.16rem;
  font-weight: bold;
}

.contentitem {
  height: 0.41rem;
  font-size: 0.16rem;
  line-height: 0.41rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.main {
  padding: 0 0 0.5rem;
}

.content {
  padding: 0rem 0.15rem;
  line-height: 0.2rem;
}

.bottom {
  width: 100%;
  height: 0.49rem;
  line-height: 0.49rem;
  color: #fff;
  font-size: 0.18rem;
  text-align: center;
  position: fixed;
  bottom: 0px;
  left: 0px;
}

.right {
  position: fixed;
  top: 1rem;
  right: 0px;
  width: 0.38rem;
  background-color: #fff;
  padding: 0;
  height: 75vh;
  overflow-y: scroll;
}

.right span {
  width: 100%;
  line-height: 0.16rem;
  display: inline-block;
  text-align: center;
}

.headerpicwarp {
  display: inline-block;
  width: 0.35rem;
  height: 0.41rem;
  line-height: 0.41rem;
  text-align: center;
  /* float: left; */
}

.headerpic {
  width: 0.35rem;
  height: 0.35rem;
  vertical-align: middle;
  float: left;
}

.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}

.templatepop {
  width: 3rem;
  height: 3.6rem;
  background-color: #fff;
  border-radius: 5px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -1.8rem;
  margin-left: -1.5rem;
  box-sizing: border-box;
  padding: 0.4rem 0;
  font-size: 0.15rem;
}

.popclosex {
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
}

/*************************/
.leftspan {
  display: inline-block;
  width: 0.5rem;
  text-align: center;
  margin-left: 0.2rem;
}
.listBar {
  margin-top: 0.2rem;
  background-color: #d8d8d8;
  padding: 0.08rem 0.2rem;
}
/* .listBar{
    line-height: 0.05rem;
  } */
/* .departmentList{
    padding: 0rem 0.2rem;
  } */

.searchList {
  margin-top: 0.2rem;
  padding-left: 0.2rem;
}
.listName {
  padding: 0.3rem 0.2rem;
  border-bottom: 1px solid #f5f5f5;
}
.rightImg {
  margin-top: 2px;
  float: right;
}
.rightImg img {
  height: 0.13rem;
}
.userNameList {
  padding: 0rem 0.2rem;
}
.userNameList .listTitle {
  background-color: #f4f2f3;
  padding: 0.07rem 0.2rem;
  font-size: 0.15rem;
}
</style>



// WEBPACK FOOTER //
// src/components/content/departmentListdetail.vue